module.exports = __webpack_public_path__ + "img/accept.c8cc6fbc.svg";